import { memo } from 'react';

import { SimilarToAssetChip } from '~/components/SearchCommand/SmartSearchImageSearchStatus/SimilarToAssetChip';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type ImageUploadSearchProps = {
  similarToImage: string;
};

export const ImageUploadSearch = memo(({ similarToImage }: ImageUploadSearchProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();

  const image = (
    // biome-ignore lint/performance/noImgElement: src is base64 image
    <img
      src={similarToImage}
      // biome-ignore lint/a11y/noRedundantAlt: "Search by uploaded image" is a descriptive alt text
      alt="Search by uploaded image"
      className="ui2026:block ui2026:size-full h-6 w-6 shrink-0 rounded-4 object-cover [image-rendering:smooth]"
    />
  );

  if (ui2026) {
    return (
      <SimilarToAssetChip data-testid="IMAGE_UPLOAD_SEARCH" image={image}>
        Uploaded image
      </SimilarToAssetChip>
    );
  }

  return (
    <div
      className="pointer-events-none flex h-6 items-center gap-1.5 overflow-hidden truncate rounded-4 ads:bg-ads-gray-4 bg-gray-4 pr-1.5 font-medium ads:text-primary text-12 text-gray-12"
      data-testid="IMAGE_UPLOAD_SEARCH"
    >
      {image}
      Uploaded image
    </div>
  );
});

ImageUploadSearch.displayName = 'ImageUploadSearch';
